'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearsAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/yearsAfter.js
// module id = 399
// module chunks = 1